import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { App, Skeleton } from 'antd';

import { convertTelegrammMenuToArray } from '../../../utils/convertTelegrammMenuToArray';
import { createFormData } from '../../../../../utils/common/createFormData';
import { MassBroadcastsForm } from '../components/MassBroadcastsForm';
import { MassBroadCastDTO } from '../service/broadcasts.interface';
import {
    broadcastSegmentation,
    broadcastStatus,
    sendTimeType,
} from '../utils/options';
import { formatWithTime } from '../../../../../shared/contants/date';
import {
    useLazyReadBroadcastQuery,
    useUpdateBroadcastMutation,
} from '../service/broadcasts.api';

export const MassBroadcastsEdit = () => {
    const { id, broadcastId } = useParams();
    const navigate = useNavigate();
    const [initial, setInitial] = useState<null | MassBroadCastDTO>();
    const { notification } = App.useApp();

    const [getBroadcast, { data, isLoading: isSuccessRead }] =
        useLazyReadBroadcastQuery();
    const [
        updateBroadcast,
        { isSuccess, isLoading: isLoadingCreate, isError, error },
    ] = useUpdateBroadcastMutation();

    useEffect(() => {
        if (broadcastId && id) {
            getBroadcast({ id: +id, broadcast_id: +broadcastId }, true);
        }
    }, [broadcastId, id]);

    useEffect(() => {
        if (data) {
            setInitial({
                title: data.title,
                id: data.id,
                segmentation: data.segmentation,
                chat_ids: data.chat_ids,
                send_at: data.send_at,

                status: data.status,

                type: data.content?.type,
                text: data.content?.media_caption
                    ? data.content?.media_caption
                    : data.content?.message,
                linksArray: convertTelegrammMenuToArray(data.content?.menu),
                content: data.content,
            });
        }
    }, [isSuccessRead, data]);

    const onSave = async values => {
        if (values.title === '') {
            return notification.error({
                message: 'Нужно указать  название рассылки',
            });
        }

        if (!values.text) {
            return notification.error({
                message: 'Для рассылок обязательно заполнять "Сообщение"',
            });
        }

        const data = {
            title: values.title,
            id: values.id,
            send_at:
                values.timeSelect === sendTimeType.now
                    ? formatWithTime(new Date())
                    : values.send_at,

            status: broadcastStatus.planned,
        };

        if (values.values?.linksArray?.length > 0) {
            const linksObject = values?.linksArray.reduce(
                (accumulator, current) => {
                    accumulator[current.linkKey] = current.linkValue;
                    return accumulator;
                },
                {}
            );
            data.links = JSON.stringify(linksObject);
        }

        if (values.segmentation === broadcastSegmentation.list) {
            data.chat_ids = values.chat_ids[0]?.originFileObj;
        }

        if (values.image) {
            data.image = values.image;
        }

        if (values.image || data.content?.media_url) {
            data.caption = values.text;
        } else {
            data.message = values.text;
        }

        await updateBroadcast({
            shop_id: id,
            broadcast_id: broadcastId,
            body: createFormData(data),
        });
    };

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: `Рассылка успешно создана`,
            });
            navigate(-1);
        }
    }, [isSuccess]);

    useEffect(() => {
        if (
            error &&
            error?.data.message === 'Error trying to update finished broadcast'
        ) {
            notification.error({
                message: 'Невозможно изменить уже произошедшую рассылку.',
            });
        }

        if (error && error?.data.errors) {
            {
                Object.entries(error?.data.errors).map(([key, messages]) => (
                    <Fragment key={key}>
                        {messages.map((message, index) =>
                            notification.error({
                                message: message,
                            })
                        )}
                    </Fragment>
                ));
            }
        }
    }, [error]);

    return initial && initial.title ? (
        <MassBroadcastsForm
            initialValues={initial}
            imageUrl={data.content?.media_url}
            onSave={onSave}
            loading={isLoadingCreate}
        />
    ) : (
        <Skeleton />
    );
};
